export default __webpack_public_path__ + "static/media/EKS.5d7d4569.png";